/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Microsoft_Calendar_List_ErrorInputs */

const es_tools_microsoft_calendar_list_error = /** @type {(inputs: Tools_Microsoft_Calendar_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar calendarios de Microsoft`)
};

const en_tools_microsoft_calendar_list_error = /** @type {(inputs: Tools_Microsoft_Calendar_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing Microsoft calendars`)
};

/**
* | output |
* | --- |
* | "Error listing Microsoft calendars" |
*
* @param {Tools_Microsoft_Calendar_List_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_microsoft_calendar_list_error = /** @type {((inputs?: Tools_Microsoft_Calendar_List_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Microsoft_Calendar_List_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_microsoft_calendar_list_error(inputs)
	return en_tools_microsoft_calendar_list_error(inputs)
});
export { tools_microsoft_calendar_list_error as "tools.microsoft_calendar.list_error" }